import React, { useCallback } from "react";
import { AHRoutineIcon, AHText, AHTodoCategoryIcon, Box } from "arkh";
import { graphql, useLazyLoadQuery } from "react-relay";
import { StoreAnalyticsScreenQuery } from "./__generated__/StoreAnalyticsScreenQuery.graphql";
import { IssueStatsCreatedGraph } from "../IssueStats/IssueStatsCreatedGraph";
import { IssueStatsTTRGraph } from "../IssueStats/IssueStatsTTRGraph";

import { IssueStatsTopTypes } from "../IssueStats/IssueStatsTopTypes";
import { TodoCountAnalytics } from "./TodoCountAnalytics";

import { LazyQueryNetworkBoundrary } from "../../components/mobile/QueryNetworkBoundrary";

import { useNewFetchKeyOnNav } from "../../useNewFetchKeyOnNav";
import { DateTime } from "luxon";
import { ScrollView } from "react-native";
import { KPIStoreAnalytics } from "../KPIAnalytics/KPIStoreAnalytics";

export const StoreAnalyticsScreen = () => {
  return (
    <LazyQueryNetworkBoundrary>
      {useCallback(
        (fetchKey) => (
          <StoreAnalyticsScreenC fetchKey={fetchKey} />
        ),
        []
      )}
    </LazyQueryNetworkBoundrary>
  );
};
function StoreAnalyticsScreenC(props: { fetchKey: string }) {
  const fetchKey = useNewFetchKeyOnNav(props.fetchKey);
  const fromDate = DateTime.local().minus({ days: 30 }).startOf("day").toISO();
  const data = useLazyLoadQuery<StoreAnalyticsScreenQuery>(
    graphql`
      query StoreAnalyticsScreenQuery($fromDate: String) {
        store {
          id
          issueStats {
            ...IssueStatsTopTypes_IssueStats
            ...IssueStatsTTRGraph_IssueStats
            ...IssueStatsCreatedGraph_IssueStats
          }
          kpis {
            id
            title
            icon
            ...KPIStoreAnalytics_KPI
          }
          todoCategories {
            id
            title
            icon
            stats {
              ...TodoCountAnalytics_TodoStats
            }
          }
        }
      }
    `,
    {
      fromDate,
    },
    { fetchKey }
  );

  return (
    <ScrollView>
      <Box spaceVertical="large" spaceHorizontal="medium">
        <IssueStatsTopTypes issueStats={data.store.issueStats} />
      </Box>
      <Box spaceVertical="large">
        <IssueStatsTTRGraph issueStats={data.store.issueStats} />
      </Box>
      <Box spaceVertical="large">
        <IssueStatsCreatedGraph issueStats={data.store.issueStats} />
      </Box>
      {data.store.kpis.map((kpi) => {
        return (
          <Box key={kpi.id} spaceVertical="large">
            <Box
              spaceHorizontal="large"
              style={{ flexDirection: "row", alignItems: "center" }}
            >
              <AHRoutineIcon type={kpi.icon ?? "key"} />
              <AHText spaceLeft="small" type="title">
                {kpi.title}
              </AHText>
            </Box>
            <KPIStoreAnalytics kpi={kpi} />
          </Box>
        );
      })}
      {data.store.todoCategories.map((tc) => {
        if (!tc.stats) {
          return null;
        }
        return (
          <Box key={tc.id} spaceVertical="large">
            <Box
              spaceHorizontal="large"
              style={{ flexDirection: "row", alignItems: "center" }}
            >
              <AHTodoCategoryIcon icon={tc.icon ?? "Check"} />
              <AHText spaceLeft="small" type="title">
                {tc.title}
              </AHText>
            </Box>
            <TodoCountAnalytics todoCountAnalytics={tc.stats} />
          </Box>
        );
      })}
    </ScrollView>
  );
}
